"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("../Box"));

var _core = require("@emotion/core");

var __jsx = _react["default"].createElement;
var animation = (0, _core.keyframes)({
  from: {
    transform: "rotate(360deg)"
  },
  to: {
    transform: "rotate(0deg)"
  }
});

var Spinner = function Spinner(_ref) {
  var _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? {} : _ref$sx,
      _ref$light = _ref.light,
      light = _ref$light === void 0 ? true : _ref$light;
  var color = sx.$color || "inherit";
  var color2 = sx.$color2 || "lightgrey";
  var width = sx.$width || 2;
  var styles = {
    position: "absolute",
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    textIndent: "-9999em",
    borderWidth: width,
    borderStyle: "solid",
    borderTopColor: color2,
    borderRightColor: color2,
    borderBottomColor: color2,
    borderLeftColor: color,
    transform: "translateZ(0)",
    animation: "".concat(animation, " 1s infinite linear"),
    overflow: "hidden"
  };
  return __jsx(_Box["default"], {
    sx: [{
      position: "relative",
      width: "24px"
    }, sx]
  }, __jsx(_Box["default"], {
    sx: {
      pb: "100%"
    }
  }, __jsx(_Box["default"], {
    sx: styles
  }, "Spin...")));
};

var _default = Spinner;
exports["default"] = _default;